/* eslint-disable */
import { guardMaxLengthArray, guardUnspecified } from '@portal/utils/util-guards';

const getDevices = block =>
  Object.entries(block.settings.types).reduce((acc, [key, value]) => {
    if (value) {
      acc.push(key);
    }
    return acc;
  }, []);

export const blockToComponent = (
  block,
  blocksToComponentsMap,
  isRedesignColumn = false,
) => {
  const advTypes = ['adv', 'flyroll_advert', 'mobile_record_inread_advert'];

  if (blocksToComponentsMap[block.type] === undefined) {
    return {
      is: 'div',
      'data-block-type': block.type,
      hidden: true
    };
  }

  const component = {
    is: blocksToComponentsMap[block.type],
    data: block
  };

  if (block.type === 'forum') {
    component.styleType = block.settings.style || 'grid';
  }

  if (!advTypes.includes(block.type)) {
    component.class = {
      ...block.settings.types,
      _central: block.type === 'auto'
    };
  }

  if (advTypes.includes(block.type)) {
    component.adv = block;
  }

  if (block.type === 'comments') {
    component.pagesize = block.params.pagesize;
    component.settings = block.settings;
  }

  if (block.type === 'auto') {
    component.type = 'Auto';
    component.devices = getDevices(block);
  }

  if (block.type === 'avito_auto') {
    component.type = 'Avito';
    component.devices = getDevices(block);
  }

  if (block.type === 'authors_records') {
    const MAX_AUTHOR_RECORDS = 3;
    const authorRecords = block.data;
    const visibleAuthorRecords = authorRecords.slice(0, MAX_AUTHOR_RECORDS);

    component.items = visibleAuthorRecords;
    component.title = block.params.title;
    component.buttonLink =
      (!guardMaxLengthArray(authorRecords, MAX_AUTHOR_RECORDS) &&
        authorRecords[0]?.authors[0]?.url) ||
      '';
  }

  if (block.type === 'record_footer_author') {
    component.items = block.data;
    component.isOpinion = block.isOpinion ?? false;
  }

  if (block.type === 'record_footer_votes') {
    component.items = block.data;
  }

  if (block.type === 'record_footer_tags') {
    component.tags = block.data;
  }

  if (block.type === 'similar_records') {
    if (guardUnspecified(block.data?.data)) {
      component.recordList = block.data.data.map(item => {
        return {
          ...item,
          type: block.data.meta.editorialRecordIDs.includes(item.id) ? 'MN' : 'ML'
        };
      });
    } else {
      component.recordList = [];
    }
  }

  if (block.type === 'relap') {
    component.partnerId = block.data.id;
  }

  if (block.type === 'smi2') {
    component.partnerId = block.data.id;
    component.devices = guardUnspecified(block.settings.types)
      ? getDevices(block)
      : ['desktop', 'mobile', 'tablet'];
  }

  if (block.type === 'smi24') {
    component.partnerId = block.data.id;
    component.devices = guardUnspecified(block.settings.types)
      ? getDevices(block)
      : ['desktop', 'mobile', 'tablet'];
  }

  if (block.type === 'sparrow') {
    component.keyDesktop = block.data.dataKeyDesktop;
    component.keyMobile = block.data.dataKeyMobile;
    component.sid = block.data.sid;
    component.devices = guardUnspecified(block.settings.types)
      ? getDevices(block)
      : ['desktop', 'mobile', 'tablet'];
  }

  if (block.type === 'smi2_video') {
    component.content = block.data;
  }

  if (block.type === 'yandex_recommended_widget') {
    component.content = block.data;
  }

  return component;
};
